import { authComputed } from '@state/helpers'
import { email, required } from 'vuelidate/lib/validators'

export const EVENT_DETAILS_VALIDATIONS = {
  eventForm: {
    name: {
      required,
    },
    groupId: {
      required,
    },
    address1: {
      required,
    },
    city: {
      required,
    },
    state: {
      required,
    },
    zip: {
      required,
    },
    locationName: {
      required,
    },
    maxPeople: {
      required,
    },
    minAge: {},
    imageUrl: {
      required,
    },
  },
}

export const EVENT_ATTENDEE_VALIDATIONS = {
  attendeeForm: {
    name: {
      required,
    },
    email: {
      required,
      email,
    },
  },
}
const notCurrentUserEmail = (value, vm) =>
  value !== authComputed.currentUser.email
export const EVENT_GUESTS_VALIDATIONS = {
  guests: {
    $each: {
      id: {},
      name: { required },
      email: {
        required,
        email,
        notCurrentUserEmail,
      },
      phone: {},
      image_url: {},
    },
  },
}

export const OPTIONS = [
  { name: 'No', value: 0 },
  { name: 'Yes', value: 1 },
]

export const RECURRING_FREQUENCY_UNIT_VALUES = [
  { name: 'Select', value: '', hasChildren: false },
  { name: 'day(s)', value: 'd', hasChildren: false },
  { name: 'week(s)', value: 'w', hasChildren: false },
  { name: 'month(s)', value: 'm', hasChildren: false },
  { name: 'year(s)', value: 'y', hasChildren: false },
]

export const RECURRING_REPEAT_VALUES = [
  { name: 'None', value: 'f', hasChildren: false },
  { name: 'Every Day', value: 'd', hasChildren: false },
  { name: 'Every Week', value: 'w', hasChildren: false },
  { name: 'Every Month', value: 'm', hasChildren: false },
]

export const RECURRING_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const RECURRING_DAYS_JS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export const RECURRING_PREFIXES = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
]

export const EVENT_MINIMUM_AGES = [
  { name: 'All ages', value: 'All ages' },
  { name: '5+', value: '5+' },
  { name: '10+', value: '10+' },
  { name: '12+', value: '12+' },
  { name: '13+', value: '13+' },
  { name: '14+', value: '14+' },
  { name: '16+', value: '16+' },
  { name: '18+', value: '18+' },
  { name: '21+', value: '21+' },
]

export const EVENT_ONGOING = [
  { name: 'No', value: 0 },
  { name: 'Yes', value: 1 },
]

export const SCRIPTS = {
  jQuery: process.env.VUE_APP_PUBLIC_PATH + 'js/jquery.min.js',
  jQueryUI: process.env.VUE_APP_PUBLIC_PATH + 'js/jquery-ui.min.js',
  formBuilder: process.env.VUE_APP_PUBLIC_PATH + 'js/form-builder.min.js',
  formRender: process.env.VUE_APP_PUBLIC_PATH + 'js/form-render.min.js',
  addToCalendar: process.env.VUE_APP_PUBLIC_PATH + 'js/atc.min.js',
}

export const FORM_BUILDER_OPTIONS = {
  showActionButtons: false,
  editOnAdd: true,
  typeUserDisabledAttrs: {
    text: [
      'access',
      'inline',
      'max',
      'maxlength',
      'min',
      'other',
      'rows',
      'step',
      'style',
      'toggle',
      'value',
      'values',
    ],

    header: ['access'],

    paragraph: ['access'],

    select: ['access', 'multiple'],

    checkbox: ['access', 'inline', 'other', 'toggle'],
  },
}

export const NEW_GUEST_DATA = {
  id: 0,
  name: '',
  email: '',
  phone: '',
  image_url: '',
  pivot: {
    registration_form_data: '',
  },
}
